
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"10","stroke":"#F3F5F5","stroke-width":"4"}}),_c('path',{attrs:{"d":"M12 2a10 10 0 0110 10","stroke":"currentColor","stroke-width":"4","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    